import { apiClient } from './client';

export interface UserCreate {
  kakao_id: string;
  email?: string;
  nickname?: string;  // 카카오 프로필 닉네임
  name?: string;  // 실명
  phone?: string;
  birth_date?: string;  // 생년월일 (YYYY-MM-DD)
}

export interface UserResponse {
  id: number;
  kakao_id: string;
  email?: string;
  nickname?: string;  // 카카오 프로필 닉네임
  name?: string;  // 실명
  phone?: string;
  birth_date?: string;  // 생년월일
  profile_image?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  last_login_at?: string;
}

export interface IssuedCoupon {
  id: number;
  name: string;
  description?: string;
  discount_type: string;
  discount_value: number;
  valid_until: string;
}

export interface UserLoginResponse {
  user: UserResponse;
  access_token: string;
  token_type: string;
  is_new_user?: boolean;  // 신규 회원 여부
  issued_coupons?: IssuedCoupon[];  // 발급된 쿠폰 목록
}

/**
 * 카카오 로그인 시 사용자 생성 또는 업데이트
 * JWT 토큰과 함께 반환
 */
export const createOrUpdateUser = async (userData: UserCreate): Promise<UserLoginResponse> => {
  const response = await apiClient.post<UserLoginResponse>('/users/', userData);
  return response.data;
};

/**
 * 카카오 ID로 사용자 조회
 */
export const getUserByKakaoId = async (kakaoId: string): Promise<UserResponse> => {
  const response = await apiClient.get<UserResponse>(`/users/kakao/${kakaoId}`);
  return response.data;
};
